// extracted by mini-css-extract-plugin
export default {"eye_chart_font":"visualAcuity_eye_chart_font__BxB5W","snellen_chart_font":"visualAcuity_snellen_chart_font__5rx64","sloan_chart_font":"visualAcuity_sloan_chart_font__M3uBj"};